export default __webpack_public_path__ + "static/media/forest.61123f1516bc6d6db4b837517ea8ec87.svg";